import { WITHDRAWAL } from "../../actions/type";

export default function withdrawal(state = {}, action) {
    switch (action.type) {
        case WITHDRAWAL:
            return action.payload;
        default:
            return state
    }
}